window.$crisp = [];
window.CRISP_WEBSITE_ID = "61d2bd78-697a-4d2b-a9da-94e028c5607c";

var s = document.createElement("script")
s.src = "https://client.crisp.chat/l.js"
s.async = 1
document.getElementsByTagName("head")[0].appendChild(s)
